import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LdCorrelationTypeIconWithQualityComponent } from '@app/main/leak-detection/components/ld-helper/ld-correlation-type-icon-with-quality/ld-correlation-type-icon-with-quality.component';
import { FpCorrelationGraphStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/services/fp-correlation-graph/fp-correlation-graph.store';
import { FpCorrelationGraphInfoLeakComponent } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/components/fp-correlation-graph-info-leak/fp-correlation-graph-info-leak.component';
import { FloatingPopupService } from '@app/main/main-content/floating-popup-manager/services/floating-popup.service';
import { NgClass } from '@angular/common';
import { ScreenResolutionService } from '@app/core/services/screen-resolution/screen-resolution.service';

@Component({
  selector: 'gc-fp-correlation-graph-info',
  standalone: true,
  imports: [LdCorrelationTypeIconWithQualityComponent, FpCorrelationGraphInfoLeakComponent, NgClass],
  templateUrl: './fp-correlation-graph-info.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FpCorrelationGraphInfoComponent {
  protected readonly screenResolutionService = inject(ScreenResolutionService);
  protected readonly floatingPopupService = inject(FloatingPopupService);
  public readonly currentTabStore = inject(FpCorrelationGraphStore);
  public isRowView = input<boolean>(false);
  public shortView = input<boolean>(false);
  public showSeparator = input<boolean>(false);
  public showRounded = input<boolean>(false);
  public isMinimizedView = input<boolean>(false);

  private readonly popupMainData = toSignal(this.currentTabStore.popupMainData$, {
    initialValue: null,
  });

  public readonly correlation = computed(() => this.popupMainData()?.correlation);
}
